import { useEffect, useState } from 'react'

// Matches Tailwind's `lg` breakpoint, the width AdminNav switches from a
// drawer to static in-flow at. In rem, not the equivalent 1024px: a media
// query in px cannot see a browser's default font size, so a visitor who
// has raised theirs would cross Tailwind's `lg:` classes at a narrower
// width than this hook did, leaving the two disagreeing about which state
// the page is in.
const DESKTOP_QUERY = '(min-width: 64rem)'

function isDesktopViewport(): boolean {
  return typeof matchMedia === 'function' && matchMedia(DESKTOP_QUERY).matches
}

/**
 * Tracks the `lg` breakpoint so AdminNav's closed drawer, and the page
 * content its open drawer covers, can each be made inert only below it:
 * `inert` has no media-query form of its own, and applying it whenever a
 * drawer's own `open` state says so would also disable the always-visible
 * desktop nav, which ignores that state entirely.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(isDesktopViewport)

  useEffect(() => {
    if (typeof matchMedia !== 'function') return
    const query = matchMedia(DESKTOP_QUERY)
    const onChange = () => setIsDesktop(query.matches)
    query.addEventListener('change', onChange)
    return () => query.removeEventListener('change', onChange)
  }, [])

  return isDesktop
}
